import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    statusContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      minHeight: 200,
      paddingTop: 10,
      width: '100%',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    iconButtonPrevious: {
      '&:hover': {
        background: 'none',
      },
    },

    flexItem: {
      margin: 5,
    },
    iconButtonNext: {
      '&:hover': {
        background: 'none',
      },
    },
    outerBox: {},
  })
)

export default useStyles
